import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SubNav from "../../navbar/subNav";
import "./ViewPropertyDetails.css";
import CustomModal from "../../input-components/Modal";
import ShowValue from "../../input-components/ShowValue";
import TextBox from "../../input-components/textbox";
import { addrentreceipt, propertyDetails, getAgreementDocumentListForProperty, generatePdfReport, generatetenantcheckreport, generatesalesagreementPdfReport, generateTenantAgreementPdfReport, FilePath, assignedTo, getmaintenanceListforportalforproperty, deletepropertylisting, getviewreceiptdetails, updateinspectiondate, addupdatetenantpaymentmethod, getinspectionspagedlist,generateentryexitinspectionreport ,generateroutineinspectionreport,addupdateagreementterms } from "../../../components/CommonSection/apiresources";
import { makeRequestWithSpinner, DownloadFiletWithSpinner } from "../../../Utilities/client";
import { GetCookie, currentProfile } from "../../../components/CommonSection/Cookie/Session";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus, eAgreementTemplateType } from "../../../Utilities/enum";
import AddTenant from "./TenantPropertyAgency";
import AddTenantFolio from "./TenantFolio"
import { BiBath, BiBed, BiCar } from "react-icons/bi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { dynamicUrl } from "../../../Utilities/profileManagement";
import { Table, Button, Select, Input, Space, Dropdown,Tag } from "antd";
import { DownloadOutlined, PlusOutlined, UploadOutlined, DollarOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import ImageGalleryModal from "../../input-components/imageGallary";
import MainPropertyComponent from "./propertyModal"
import axios from "axios";
import PropertyDocumentsAgency from "./propertyDocuments";
import AntdTableExample from "../../input-components/dataTable";
import { FormatDateView } from "../../../components/CommonSection/Utility/Utility";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import NewTenantReceipt from "../../view/Accounts/newReceipt";
import ToggleTabs from "../../input-components/toggleButtonTabs";
import chunk from "lodash/chunk"; 

const ViewPropertDetails = ({ }) => {
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const navigate = useNavigate();
    const [ppenAddNewReceipt, setOpenAddNewReceipt] = useState(false);
    const [activeTab, setActiveTab] = useState("Overview");
    const [activeTabTenant, setActiveTabTenant] = useState("Tenant");
    const [openAddNewtenant, setOpenAddNewtenant] = useState(false);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(4);
    const [amount, setAmount] = useState("");
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [getDetails, setGetDetails] = useState(null);
    const [docfile, setDocfile] = useState(null);
    const [ownerCollapse, setOwnerCollapse] = useState(true);
    const [listingCollapse, setListingCollapse] = useState(true);
    const [agreementCollapse, setAgreementCollapse] = useState(true);
    const [tenantCollapse, setTenantCollapse] = useState(true);
    const [galleryPropertyImages, setGallaryPropertyImages] = useState([]);
    const [galleryFloorImages, setGallaryFloorImages] = useState([])
    const [photosCollapse, setPhotosCollapse] = useState(true);
    const [legalCollapse, setLegalCollapse] = useState(true);
    const [maintainanceStatus, setMaintainanceStatus] = useState(0);
    const [maintainanceList, setMaintainanceList] = useState([]);
    const [listCount, setListCount] = useState({})
    const [getDocDetails, setGetDocDetails] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [openAddProperty, setOpenAddProperty] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [resetAllPage, setResetAllPage] = useState(false);
    const [dpdata, setDpdata] = useState([]);
    const [tenantId, setTenantId] = useState(null);
    const [tenantEdit, setTenantEdit] = useState(false)
    const [tenantFolipCollapse, setTenantFolipCollapse] = useState(true);
    const [listingType, setListingType] = useState("");
    const [receiptDetails, setReceiptDetails] = useState({});
    const [rentAmount, setRentAmount] = useState(null);
    const [invoiceAmounts, setInvoiceAmounts] = useState([]);
    const [inspectionData, setInspectionData] = useState({
        InspectionDue: null,
        InspectionFrequency: '',
        InspectionFrequencyType: 1
    });
    const [rentData, setRentData] = useState([
        { allocation: "Rent", due: "21 Sep 2024", description: "Paid to 21/09/2024", amountDue: "13 days", amount: "" }
    ]);
    const [depositData, setDepositData] = useState([
        { description: "", amount: "" }
    ]);
    const ePaymentModes = [
        { value: 5, label: "BPay" },
        { value: 4, label: "EFT" }
    ];
    var url = new URL(window.location.href);
    var propertyUId = url.searchParams.get("propertyUID");
    var step = url.searchParams.get("step");
    var editfolio = url.searchParams.get("folio");
    const [tenantFolioId, setTenantFolioId] = useState(null);
    const [inspectionLists, setInspectionLists] = useState([]);

    const currentUser = currentProfile.get();
    const [openAddFrequency, setOpenAddFrequency] = useState(false);

    const [openAddAgreement, setOpenAddAgreement] = useState(false);
    const [agreementStartDate, setAgreementStartDate] = useState('')
    const [agreementEndDate, setAgreementEndDate] = useState('')

    const ToastRef = useRef();

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                    setTenantFolioId(parsedData.tenantFolioId)
                    reportData(parsedData.agencyUniqueID);

                } else {
                    navigate("/signin");
                }
            } catch (error) {
                console.error("Error retrieving data:", error);
            }
        };
        retrieveData();
    }, [userId]);

    const reportData = (agencyUID) => {
        const apiUrl = assignedTo;
        const baseUrl = apiUrl + "?agencyUID=" + agencyUID;
        axios.get(baseUrl).then((response) => {
            if (response.data.object) setDpdata(response.data.object);
        });
    };


    useEffect(() => {
        getPropertyDetails(propertyUId);
        if (step === "tenant") {
            setOpenAddNewtenant(true);
            setActiveTabTenant("Rent Details")
        }
        else if (step) {
            setOpenAddProperty(true);
            setCurrentStep(parseInt(step))
        }
    }, [])

    const viewreceiptdetails = (value) => {
        const baseUrl = getviewreceiptdetails;
        const apiUrl = `${baseUrl}?PropertyId=${value}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setReceiptDetails(response.object)
                } else {
                    //handleparentsuccess(["warn", response.data.message]);
                }
            })
            .catch((error) => {
                //handleparentsuccess(["error", error]);
            });
    };

    const getPropertyDetails = (value, rent) => {
        const baseUrl = propertyDetails;
        const apiUrl = `${baseUrl}?propertyID=${value}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setGetDetails(response.object);

                    let PropertyImages = response.object?.propertyPics?.map(item => ({
                        fileName: `${FilePath}${item}`
                    }));
                    let FloorImages = response.object?.floorPics?.map(item => ({
                        fileName: `${FilePath}${item}`
                    }));

                    setGallaryPropertyImages(PropertyImages);
                    setGallaryFloorImages(FloorImages);
                    GetDocumentsApi(response.object);
                    if (rent) {
                        setActiveTabTenant(rent)
                    }
                    const inspectionFrequency = response.object?.inspectionFrequency || '';
                    const inspectionFrequencyType = response.object?.inspectionFrequencyType || null;
                    const inspectionDue = response.object?.inspectionDue
                        ? moment(response.object.inspectionDue).format('YYYY-MM-DD')
                        : null;

                    setInspectionData({
                        InspectionDue: inspectionDue,
                        InspectionFrequency: inspectionFrequency,
                        InspectionFrequencyType: inspectionFrequencyType
                    });
                    const paymentMethods = response.object?.tenantFolioDetails?.paymentMethods?.map(method => ({
                        method: method.paymentMethod,
                        payee: method.paymentMethod === 2 ? method.chequePayeeName : method.accountName,
                        bsb: method.accountBSB || "",
                        account: method.accountNumber || "",
                        split: method.split || 0,
                        isPercentage: method.splitType === 1
                    })) || [];
                    setPaymentMethods(paymentMethods)

                } else {
                    //handleparentsuccess(["warn", response.data.message]);
                }
            })
            .catch((error) => {
                //handleparentsuccess(["error", error]);
            });
    };


    const GetDocumentsApi = (data) => {
        const formData = {
            PropertyId: data.propertyId,
            AgencyId: data.agencyId
        }
        const baseUrl = getAgreementDocumentListForProperty;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formData)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setGetDocDetails(response.list);
                } else {
                    //handleparentsuccess(["warn", response.data.message]);
                }
            })
            .catch((error) => {
                handleparentsuccess(["error", error]);
            });
    };
    const handleReceiptSubmit = (formData) => {
        const payload = {
            Id: 0,
            Type: 1,
            Date: new Date().toISOString(),
            PaymentMode: selectedPaymentMode,
            Description: receiptDetails.propertyAddress,
            PropertyId: getDetails.propertyId,
            AgencyId: agencyID,
            UserId: userId,
            ...formData,
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addrentreceipt, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    closeReceipt();
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
    };



    const handleOpenReceipt = () => {
        setOpenAddNewReceipt(true);
        setDepositData([{ description: "", amount: "" }]);
        setAmount("")
        setRentAmount(null)
        setInvoiceAmounts([])
        viewreceiptdetails(getDetails.propertyId);
    };

    const closeReceipt = () => {
        setOpenAddNewReceipt(false);
        setReceiptDetails({});
        setAmount(0);
        setRentAmount(null);
        setInvoiceAmounts([]);
        setDepositData([{ description: "", amount: "" }]);
        setTenantValues("");
        setRentData([
            {
                allocation: "Rent",
                due: "",
                description: "",
                amountDue: "",
                amount: ""
            }
        ]);
    };

    const closeTenant = () => {
        setOpenAddNewtenant(false);
        getPropertyDetails(propertyUId);
        setActiveTabTenant("Tenant")
        setTenantEdit(false)
    }

    const handleOpenAddTenant = (id = null, edit = false, rent = null) => {
        if (primaryOwners.length === 0) {
            ToastRef.current.notify(["error", "Owner is required in order to create tenant."]);
            return;
        }

        setOpenAddNewtenant(true);

        if (edit) {
            setTenantEdit(true);
            setTenantId(id); // Set specific tenant ID for editing
            if (rent) {
                setActiveTabTenant(rent);
            }
        } else {
            setTenantEdit(false);
            setTenantId(null); // Reset ID for fresh form
        }
    };



    const getTrueProperties = (details) => {
        if (!details || typeof details !== "object") {
            return "";
        }
        const trueProps = [];

        for (const [key, value] of Object.entries(details)) {
            if (value === true) {
                // Convert camelCase to human-readable format
                const formattedKey = key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase());
                trueProps.push(formattedKey);
            }
        }

        return trueProps.join(", ");
    };

    const tabs = ["Overview", "Activity", "Documents", "Maintainance", "Inspection"];
    const tenantTabs = ["Tenant", "Rent Details", "Payment Method"]
    const primaryOwners = getDetails?.contactlistModel.filter((contact) => contact.isPrimary);
    const secondaryOwners = getDetails?.contactlistModel.filter((contact) => !contact.isPrimary);
    const primarytenantDetails = getDetails?.tenantDetails?.filter((tenant) => tenant.primaryTenant);
    const secondarytenantDetails = getDetails?.tenantDetails?.filter((tenant) => !tenant.primaryTenant);
    const tenantPortfolioDetails = getDetails?.tenantDetails?.[0]?.tenantFolioDetails;

    const saleListing = getDetails?.listingDetails.filter((listing) => listing.propertySaleRental === 1);
    const rentListing = getDetails?.listingDetails.filter((listing) => listing.propertySaleRental === 2);

    const handleOwner = () => {
        setOwnerCollapse(!ownerCollapse)
    }

    const handleAgreement = () => {
        setAgreementCollapse(!agreementCollapse)
    }

    const handleListings = () => {
        setListingCollapse(!listingCollapse)
    }

    const handleTenant = () => {
        setTenantCollapse(!tenantCollapse)
    }

    const handleTenantFolid = () => {
        setTenantFolipCollapse(!tenantFolipCollapse)
    }

    const handlePhotos = () => {
        setPhotosCollapse(!photosCollapse)
    }

    const handleLegal = () => {
        setLegalCollapse(!legalCollapse)
    }

    const handleDownload = (record) => {
        if (record.docType === eAgreementTemplateType.ManagementAgreement) {
            if (record.isManuallyAdded) {
                const fileUrl = `${FilePath}${record.agreementFilePath}`;
                window.open(fileUrl, "_blank");
            } else {
                handleAgreementDownload(record);
            }
        } else if (record.docType === eAgreementTemplateType.TenantCheck) {
            if (record.isManuallyAdded) {
                const fileUrl = `${FilePath}${record.agreementFilePath}`;
                window.open(fileUrl, "_blank");
            } else {
                handleTenantDownload(record, 10);
            }
        }
        else if (record.docType === eAgreementTemplateType.OwnerCheck) {
            if (record.isManuallyAdded) {
                const fileUrl = `${FilePath}${record.agreementFilePath}`;
                window.open(fileUrl, "_blank");
            } else {
                handleTenantDownload(record, 11);
            }
        } else if (record.docType === eAgreementTemplateType.ExclusiveAgencyAgreement) {
            if (record.isManuallyAdded) {
                const fileUrl = `${FilePath}${record.agreementFilePath}`;
                window.open(fileUrl, "_blank");
            } else {
                handleSaleAgreementDownload(record);
            }
        } else if (record.docType === eAgreementTemplateType.TenantLeaseAgreement) {
            if (record.isManuallyAdded) {
                const fileUrl = `${FilePath}${record.agreementFilePath}`;
                window.open(fileUrl, "_blank");
            } else {
                handleTenantAgreementDownload(record);
            }
        }
    };

    const handleTenantDownload = (records, id) => {
        const formData = {
            AgencyId: getDetails.agencyId,
            UserId: records.userId,
            ReportType: id
        };
        DownloadFiletWithSpinner(
            showSpinner,
            hideSpinner,
            generatetenantcheckreport,
            "post",
            formData,
            null,
            false
        )
            .then((returnData) => {
                if (returnData != null) {
                    window.open(returnData, "_blank");
                } else {
                    ToastRef.current.notify(["error", "Internal Server Error"]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };


    const handleCreateAgreement = (rowData) => {
        if (getDetails.agentId) {
            if (rowData.title === "Management Agreement") {
                dynamicUrl(navigate, "agreementtabs" + `?propertyUID=${propertyUId}&agencyId=${getDetails.agencyId}&properties=true&viewDetails=true`);
            }
            if (rowData.title === "Residential Tenancy Agreement") {
                dynamicUrl(navigate, "tenancyagreement" + `?propertyUID=${propertyUId}&agencyId=${getDetails.agencyId}&properties=true&viewDetails=true`);
            }
            if (rowData.title === "Exclusive Sales Agency Agreement") {
                dynamicUrl(navigate, "SaleAgreementTabs" + `?propertyUID=${propertyUId}&agencyId=${getDetails.agencyId}&properties=true&viewDetails=true`);
            }
        } else {
            ToastRef.current.notify(["error", "Agent is required!"]);
            handleOpenProperty(1)
        }
    }

    const handleAgreementDownload = (record) => {
        const formData = {
            PropertyUId: record.propertyUniqueId,
        };
        DownloadFiletWithSpinner(
            showSpinner,
            hideSpinner,
            generatePdfReport,
            "post",
            formData,
            null,
            false
        )
            .then((returnData) => {
                if (returnData != null) {
                    window.open(returnData, "_blank");
                } else {
                    ToastRef.current.notify(["error", "Internal Server Error"]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };

    const handleTenantAgreementDownload = (record) => {
        const formData = {
            PropertyUId: record.propertyUniqueId,
        };
        DownloadFiletWithSpinner(
            showSpinner,
            hideSpinner,
            generateTenantAgreementPdfReport,
            "post",
            formData,
            null,
            false
        )
            .then((returnData) => {
                if (returnData != null) {
                    window.open(returnData, "_blank");
                } else {
                    ToastRef.current.notify(["error", "Internal Server Error"]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };

    const handleSaleAgreementDownload = (record) => {
        const formData = {
            PropertyUId: record.propertyUniqueId,
        };
        DownloadFiletWithSpinner(
            showSpinner,
            hideSpinner,
            generatesalesagreementPdfReport,
            "post",
            formData,
            null,
            false
        )
            .then((returnData) => {
                if (returnData != null) {
                    window.open(returnData, "_blank");
                } else {
                    ToastRef.current.notify(["error", "Internal Server Error"]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };

    const columns = [
        {
            title: "Agreement Type",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => text ? moment(text).format("DD/MM/YYYY") : "-", // Display "-" if no createdAt date
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (text ? text : "-"),
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <div>
                    <PlusOutlined title="Add Agreement" style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => handleCreateAgreement(record)} />
                    <UploadOutlined title="Upload Agreement" style={{ fontSize: "20px", marginLeft: "10px", cursor: "pointer" }} onClick={() => handleUploadAgreement(record)} />

                    {record.isCompleted ? (
                        <DownloadOutlined title="Download Agreement" style={{ fontSize: '20px', cursor: 'pointer', marginLeft: "10px" }} onClick={() => handleDownload(record)} />
                    ) : record.status ? (
                        <img src="/assets/images/view.svg" alt="View Agreement" title="View Agreement" style={{ cursor: "pointer", width: '20px', marginLeft: "10px" }} onClick={() => handleCreateAgreement(record)} />) : (null
                    )
                    }
                </div>
            ),
        },
    ];

    const renderListingDetails = (listingType, listings) => (
        listings?.map((listing) => (
            <div key={listing.listingId} className={saleListing.length > 0 && rentListing.length > 0 ? "col-lg-6" : "col-lg-12"}>
                <div className="col-lg-12 mt-2 detailsContainer">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>{listingType}</div>
                        <div className="d-flex">
                            <div className="editbtn mr-4" onClick={() => handleOpenProperty(3, listingType)}>
                                <EditOutlined className="mr-1" />Edit
                            </div>
                            <div className="editbtn" onClick={() => handleDelete(listings)}>
                                <img className="mr-1" src="/assets/images/trash.png" width={15} alt="edit icon" />Delete
                            </div>
                        </div>
                    </div>
                    <div className="owner-details">
                        <ShowValue Label="Property For" setData={listing.propertySaleRental === 1 ? "Sale" : "Rent"} />
                        <ShowValue active={listing.sListingStatus === "Active"} Label="Listing Status" setData={listing.sListingStatus || "-"} />
                        <ShowValue Label="Is Commercial" setData={listing.isCommercial ? "Yes" : "No"} />
                        <ShowValue Label="New or Established" setData={listing.isNew ? "Yes" : "No"} />
                        {listingType === "Sale Listing" ? <ShowValue Label="Agreement Type" setData={listing.propertyAgreementType || "-"} /> : null}
                        {listingType === "Rent Listing" ? <ShowValue Label="Rent Inverval" setData={getDetails.rentTenure === 1 ? "Weekly" : "Monthly" || "-"} /> : null}
                        {listingType === "Sale Listing" ? <ShowValue Label="Property Price" setData={"$" + listing.propertyPrice || "-"} /> : null}
                        {listingType === "Rent Listing" ? <ShowValue Label="Rental Price" setData={"$" + listing.rent || "-"} /> : null}
                        <ShowValue Label="Listing Agent" setData={listing.listingAgentName || "-"} />
                        <ShowValue Label="Dual Agent" setData={listing.dualAgentName || "-"} />
                        {listingType === "Sale Listing" ? <ShowValue Label="Show Text" setData={listing.showText || "-"} /> : null}
                        {listingType === "Rent Listing" ? <ShowValue Label="Date Available" setData={moment(listing.dateAvailable).format("DD/MM/YYYY") || "-"} /> : null}
                    </div>
                </div>
            </div>
        ))
    );


    const renderOwnerDetails = (title, owners) => (
        owners?.map((owner) => (
            <div key={owner.contactId} style={{ width: '50%' }}>
                <div className="col-lg-12 mt-2 detailsContainer">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>{title}</div>

                    </div>
                    <div className="owner-details">
                        {title === "Primary Owner" && (
                            <ShowValue Label="Owner Folio" setData={getDetails.ownerAccountFolio || "-"} />
                        )}
                        <ShowValue Label="Name" setData={owner.name || "-"} />
                        <ShowValue Label="Email" setData={owner.contactEmail || "-"} />
                        <ShowValue Label="Phone" setData={owner.phone || "-"} />
                    </div>
                </div>
            </div>
        ))
    );

    const handleNavigateAgreement = () => {
        dynamicUrl(navigate, `AgreementActivityList?propertyId=${getDetails.propertyId}`);
    }

    const handleAdd = () => {
        setOpenAddAgreement(true)
    }


    const renderTenantPortfolioDetails = () => {
        if (!tenantPortfolioDetails) return null;

        return (

            <div className="mt-2 detailsContainer mr-1">
                <div className="d-flex">
                    <div className="owner-details">
                        <ShowValue Label="Tenant Account Folio" setData={tenantPortfolioDetails.tenantAccountFolio || "-"} />
                        <ShowValue Label="Tenant Checksum" setData={tenantPortfolioDetails.tenantChecksum || "-"} />
                        <ShowValue Label="Rent Review Frequency" setData={tenantPortfolioDetails.rentReviewFrequency ? +tenantPortfolioDetails.rentReviewFrequency + " " + "Months" : "-" || "-"} />
                        <ShowValue Label="Rent Include Tax" setData={tenantPortfolioDetails.rentIncludeTax ? "Yes" : "No"} />
                        <ShowValue Label="Rent" amt={true} setData={tenantPortfolioDetails?.rent} />
                        <ShowValue Label="Period" setData={tenantPortfolioDetails.period === 1 ? "Weekly" : "Monthly" || "-"} />
                        <ShowValue Label="Rent To Vacate" setData={tenantPortfolioDetails.getRentToVacate || "-"} amt={true} />
                        {tenantPortfolioDetails.moveIn ? <ShowValue Label="Move In" setData={FormatDateView(tenantPortfolioDetails.moveIn) || "-"}/>: null}
                    </div>
                    <div className="owner-details">
                        <ShowValue Label="Agreement" onAddIconClick={handleAdd} addIcon={<PlusOutlined  title="Add Agreement" style={{ fontSize: '14px', cursor: 'pointer',color:'steelblue' }} onClick={() => handleCreateAgreement(record)} />} onClick={() => handleNavigateAgreement()}  link={true} setData={`from ${FormatDateView(tenantPortfolioDetails.agreementStart)} to ${FormatDateView(tenantPortfolioDetails.agreementEnd)}` || "-"} /> 
                        <ShowValue Label="Abn" setData={tenantPortfolioDetails.abn || "-"} />
                        <ShowValue Label="Balance" amt={true} setData={tenantPortfolioDetails.balance || "-"} />
                        <ShowValue amt={true} Label="Bond Amount" setData={tenantPortfolioDetails.bondAmount || "-"} />
                        <ShowValue amt={true} Label="Bond In-Trust" setData={tenantPortfolioDetails.bondInTrust || "-"} />
                        {tenantPortfolioDetails.moveOut ? <ShowValue Label="Move Out" setData={FormatDateView(tenantPortfolioDetails.moveOut) || "-"} /> : null }
                    </div>
                </div>
                {tenantPortfolioDetails.paymentMethods.length > 0 ?
                    <div>
                        <div className="detailsCollapse mt-2">
                            Payment Method
                        </div>
                        <Table dataSource={tenantPortfolioDetails.paymentMethods} columns={columnPaymentMethod} rowKey="key" pagination={false} />
                    </div> : null}
            </div>

        );
    };



    const columnPaymentMethod = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Account Name",
            dataIndex: "accountName",
            key: "accountName",
        },
        {
            title: "Account Number",
            dataIndex: "accountNumber",
        },
        {
            title: "Split",
            dataIndex: "split",
        },
        {
            title: "Payment Method",
            dataIndex: "paymentMethod",
            render: (text) => (text === 1 ? "Cash" : text === 2 ? "Cheque" : text === 3 ? "Card" : "EFT"),

        },
    ];

    const renderTenantInfo = (title, tenants) => {
        return (
            <div className="row d-flex flex-wrap gap-3 mr-1" style={{ width: '100%' }}>
                {tenants?.map((tenant) => (
                   <div key={tenant.contactId} style={{ width: '50%' }}>
                <div className="col-lg-12 mt-2 detailsContainer">
                    <div className="d-flex justify-content-between">
                            <div>{title}</div>

                        </div>
                        <div className="owner-details">
                            <ShowValue Label="Name" setData={tenant.getFullName || "-"} />
                            <ShowValue Label="Email" setData={tenant.tenantEmail || "-"} />
                            <ShowValue Label="Phone" setData={tenant.tenantMobile || "-"} />
                        </div>
                </div>
            </div>
                ))}
            </div>
             
        );

    };

    const renderLegalDetails = (legalType, listings) => (
        listings?.map((listing) => (
            <div key={listing.listingId} className={getDetails?.propertySellerConvyencor && getDetails?.propertyBuyerConvyencor ? "col-lg-6" : "col-lg-12"}>
                <div className="col-lg-12 mt-2 detailsContainer">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>{legalType}</div>

                    </div>
                    <div className="owner-details">
                        <ShowValue Label="Name" setData={listing.firmName || "-"} />
                        <ShowValue Label="Principal Name" setData={listing.principalName || "-"} />
                        <ShowValue Label="Email" setData={listing.email || "-"} />
                        <ShowValue Label="Phone" setData={listing.phone || "-"} />
                        <ShowValue Label="Address" setData={listing.address || "-"} />
                    </div>
                </div>
            </div>
        ))
    );

    const documeyArr = [
        { key: "1", title: "Management Agreement", createdAt: "", docType: eAgreementTemplateType.ManagementAgreement },
        { key: "2", title: "Residential Tenancy Agreement", createdAt: "", docType: eAgreementTemplateType.TenantLeaseAgreement },
        { key: "3", title: "Exclusive Sales Agency Agreement", createdAt: "", docType: eAgreementTemplateType.ExclusiveAgencyAgreement },
    ];

    const enhancedData = documeyArr.map((doc) => {
        const match = getDocDetails?.find((main) => main.agreementType === doc.docType);
        if (match) {
            return {
                ...doc,
                createdAt: match.createdAt,
                isCompleted: match.isCompleted,
                agreementFilePath: match.agreementFilePath,
                isManuallyAdded: match.isManuallyAdded,
                userId: match.userId,
                status: match.status,
                propertyUniqueId: match.propertyUniqueId
            };
        }

        return doc;
    });

    const handleGodBack = () => {
        dynamicUrl(navigate, "propertiesList");
    }

    const closeProperty = () => {
        debugger
        //resetUrl();
        setOpenAddProperty(false);
        setResetAllPage(false);
        getPropertyDetails(propertyUId);

    }

    const handleOpenProperty = (step, listingType) => {
        setOpenAddProperty(true);
        setResetAllPage(true);
        setCurrentStep(step);
        let type = listingType === "Sale Listing" ? 1 : listingType === "Rent Listing" ? 2 : null;
        setListingType(type)
    }


    const handleTabChange = (key) => {
        if (key === "OwnerShip") {
            setCurrentStep(2)
        } else if (key === "Listings") {
            setCurrentStep(3)
        }
    }

    const handleTabs = (tabs) => {
        setActiveTab(tabs);
        tabs === "Maintainance" ? getmaintainanceDetsils() : null
        tabs === "Inspection" ? PostApiWithSpinner(agencyID, currentUser === 13 ? tenantFolioId : null, 1) : null
    }

    const getmaintainanceDetsils = (record) => {
        const formData = {
            PropertyId: getDetails.propertyId,
            Status: record ? record : 0
        };
        makeRequestWithSpinner(
            showSpinner,
            hideSpinner,
            getmaintenanceListforportalforproperty,
            "post",
            formData,
            null,
            false
        )
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    let issueData = returnData.object.maintenanceDetails;
                    let issueList = issueData.map((issueDetails) => ({
                        Title: issueDetails.title,
                        Description: issueDetails.description,
                        CreatedDate: FormatDateView(issueDetails.createdAt),
                        maintenanceUniqueId: issueDetails.maintenanceUniqueId,
                        IssueType: issueDetails.sIssueType,
                        Tenant: issueDetails.tenantName,
                        Supplier: issueDetails.tradesmanName,
                        Status: issueDetails.sStatus,
                    }));
                    setMaintainanceList(issueList);
                    setListCount(returnData.object)
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };

    const tabColumns = {
        Status: {
            colorMap: {
                "Report Repair": "#3498db",
                "Repair Rejected": "#e74c3c",
                "Reschedule": "#f39c12",
                "Job Started": "#1abc9c",
                "Repair Approved": "#16a085",
                "Job Schedule": "#8e44ad"
            },
            defaultColor: 'blue'
        }
    };

    const handleStatClick = (selectedPurpose) => {
        setMaintainanceStatus(selectedPurpose);
        getmaintainanceDetsils(selectedPurpose)
    };

    const recallApi = () => {
        getPropertyDetails(propertyUId)
    }

    const handleDelete = (data) => {
        const baseUrl = deletepropertylisting;
        let formdata = {
            ListingId: data[0].listingId,
            AgencyId: agencyID,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formdata)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                    getPropertyDetails(propertyUId);
                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handleUploadAgreement = (rowData) => {
        if (rowData.title === "Management Agreement") {
            dynamicUrl(
                navigate,
                "UploadAgreementManagement" +
                `?propertyUID=${propertyUId}&propertyId=${getDetails.propertyId}`
            );
        } else if (rowData.title === "Residential Tenancy Agreement") {
            dynamicUrl(
                navigate,
                "UploadAgreementTenant" +
                `?propertyUID=${propertyUId}&propertyId=${getDetails.propertyId}`
            );
        } else {
            dynamicUrl(
                navigate,
                "UploadAgreement" +
                `?propertyUID=${propertyUId}&propertyId=${getDetails.propertyId}`
            );
        }
    };

    const handleAmt = (e) => {
        const newAmt = parseFloat(e.target.value) || 0;
        setAmount(newAmt);

        const invoices = receiptDetails.invoiceDueList || [];
        const updatedInvoicePayments = [];
        let remaining = newAmt;

        // 1. Allocate to invoices first
        for (const invoice of invoices) {
            const due = parseFloat(invoice.amountDue || 0);
            const pay = Math.min(due, remaining);

            updatedInvoicePayments.push({ InvoiceId: invoice.id, Amount: pay });
            remaining -= pay;

            if (remaining <= 0) break;
        }

        // 2. Remaining goes to rent (partial or full)
        const rentToApply = remaining > 0 ? remaining : 0;

        // 3. Set all state values
        setInvoiceAmounts(updatedInvoicePayments);
        setRentAmount(rentToApply);
        setDepositData([
            { description: `Deposit for ${receiptDetails.propertyAddress}`, amount: "" }
        ]);
    };


    const handlefolio = (data) => {
        let folio = data === "Owner" ? getDetails.ownerAccountFolio : tenantPortfolioDetails.tenantAccountFolio
        dynamicUrl(navigate, `accounts/folio?type=${data}&folio=${folio}`);
    }

    const handleTabChangeTenant = (id, val) => {
        getPropertyDetails(propertyUId);
        setActiveTabTenant(val)
    }

    const inspectionAccesstabs = [
        { label: 'Weekly', value: 1 },
        { label: 'Monthly', value: 2 },
    ];

    const handleInspection = () => {
        let finalData = {
            PropertyId: getDetails?.propertyId,
            InspectionDue: inspectionData.InspectionDue || null,
            InspectionFrequency: parseInt(inspectionData.InspectionFrequency) || null,
            InspectionFrequencyType: inspectionData.InspectionFrequencyType || null
        };

        const url = updateinspectiondate;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };


    const columns2 = [
        {
            title: "Method",
            dataIndex: "method",
            render: (value, row, idx) => (
                <Select
                    style={{ width: "100%" }}
                    value={value}
                    onChange={(val) => updateField(idx, "method", val)}
                >
                    {ePaymentModes.map((mode) => (
                        <Option key={mode.value} value={mode.value}>
                            {mode.label}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: "Payee",
            dataIndex: "payee",
            render: (value, row, idx) => (
                <Input value={value} onChange={(e) => updateField(idx, "payee", e.target.value)} />
            ),
        },
        {
            title: "BSB",
            dataIndex: "bsb",
            render: (value, row, idx) => (
                <Input
                    maxLength={6}
                    value={row.bsb}
                    onChange={(e) => {
                        const val = e.target.value;
                        // Allow only digits
                        if (/^\d{0,6}$/.test(val)) {
                            updateField(idx, "bsb", val);
                        }
                    }}
                    status={row.bsb && row.bsb.length !== 6 ? "error" : ""}
                />
            ),
        },
        {
            title: "Account #",
            dataIndex: "account",
            render: (value, row, idx) => (
                <Input value={value} onChange={(e) => updateField(idx, "account", e.target.value)} />
            ),
        },
        {
            title: "Split",
            dataIndex: "split",
            render: (value, row, idx) => {
                const isLast = idx === paymentMethods.length - 1;
                const isPercentageCount = paymentMethods.filter((p) => p.isPercentage).length;
                const isReadOnly = row.isPercentage && isPercentageCount > 1 && isLast;

                return (
                    <Space>

                        <Input
                            type="number"
                            style={{ width: 100 }}
                            value={value}
                            readOnly={isReadOnly}
                            variant={isReadOnly ? "filled" : ""}
                            onChange={(e) => handleSplitChange(idx, e.target.value)}
                        />
                    </Space>
                );
            },
        },
        {
            title: "Action",
            render: (_, __, idx) => (
                <DeleteOutlined style={{ color: 'red' }} onClick={() => handleRemovePaymentMethod(idx)} />
            ),
        },
    ];

    const handleAddPaymentMethod = () => {
        setPaymentMethods((prev) => {
            const totalSplit = prev.reduce((acc, p) => acc + (p.isPercentage ? (p.split || 0) : 0), 0);
            const remaining = 100 - totalSplit;
            return [...prev.map(p => ({ ...p })), { method: 4, payee: "", bsb: "", account: "", split: prev.length === 0 ? 100 : 0, isPercentage: true }];
        });
    };


    // 4. Remove Row
    const handleRemovePaymentMethod = (index) => {
        setPaymentMethods((prev) => prev.filter((_, i) => i !== index));
    };
    const updateField = (idx, field, value) => {
        const updated = [...paymentMethods];
        updated[idx][field] = value;
        setPaymentMethods(updated);
    };

    const handleSplitChange = (index, value) => {
        const updated = [...paymentMethods];
        const val = parseFloat(value) || 0;
        updated[index].split = val;

        const percentageRows = updated.filter(p => p.isPercentage);

        if (percentageRows.length > 1) {
            const totalExcludingLast = percentageRows
                .slice(0, -1)
                .reduce((acc, p) => acc + (parseFloat(p.split) || 0), 0);

            const lastIdx = [...updated]
                .map((p, i) => ({ ...p, index: i }))
                .filter(p => p.isPercentage)
                .pop()?.index;

            if (lastIdx !== undefined) {
                updated[lastIdx].split = Math.max(0, 100 - totalExcludingLast);
            }
        }

        setPaymentMethods(updated);
    };


    const toggleSplitType = (index, isPercent) => {
        const updated = [...paymentMethods];
        updated[index].isPercentage = isPercent;
        setPaymentMethods(updated);
    };

    const handleUpdatePaymentMethos = () => {

        const totalPercentage = paymentMethods
            .filter(p => p.isPercentage)
            .reduce((acc, p) => acc + (p.split || 0), 0);

        if (paymentMethods.length > 0 && totalPercentage !== 100) {
            ToastRef.current.notify(["error", "Total split percentage must equal 100%."]);
            return;
        }

        const missingMethod = paymentMethods.find(p => p.method === undefined || p.method === null || p.method === "");
        if (paymentMethods.length > 0 && missingMethod) {
            ToastRef.current.notify(["error", "Please select a payment method for all rows."]);
            return;
        }

        // 2. Validate BSB format (6 digits)
        const invalidBSB = paymentMethods.find(
            p => p.method !== 2 && (!/^\d{6}$/.test(p.bsb || ""))
        );

        if (paymentMethods.length > 0 && invalidBSB) {
            ToastRef.current?.notify(["error", "Each BSB must be exactly 6 digits."]);
            return;
        }

        if (paymentMethods.length > 0 && invalidBSB) {
            ToastRef.current?.notify(["error", "Each BSB must be exactly 6 digits."]);
            return;
        }

        const payload = {
            FolioCode: getDetails.tenantFolioDetails?.tenantAccountFolio,
            OwnerPaymentMethodDetails: paymentMethods.map((pm) => ({
                Id: 0,
                PaymentMethod: pm.method,
                ChequePayeeName: pm.method === 2 ? pm.payee : null,
                AccountName: pm.method === 2 ? null : pm.payee,
                AccountBSB: pm.method === 2 ? null : pm.bsb,
                AccountNumber: pm.method === 2 ? null : pm.account,
                BpayPayee: "",
                BillerCode: "",
                Split: pm.split,
                SplitType: pm.isPercentage ? 1 : 2
            }))
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addupdatetenantpaymentmethod, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    closeTenant()
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
    };

    const PostApiWithSpinner = (agencyID, tenantid, currentPage) => {
        const baseUrl = getinspectionspagedlist;
        let data = {
            AgencyId: agencyID,
            TabId: 1,
            PageNo: currentPage,
            PropertyId: getDetails.propertyId
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    // let propertyData = response.list;
                    const propertyData = response.list || [];
                    let propertyList = propertyData.map((property) => ({
                        Address: property.propertyAddress,
                        InspectionType: property.sInspectionType,
                        InspectionDate: property.inspectionDate ? moment(property.inspectionDate).format("DD-MM-YYYY") : "",
                        StartTime: moment(property.startTime).format('hh:mm A'),
                        EndTime: moment(property.endTime).format('hh:mm A'),
                        AssignedAgent: property.sAssignedAgent,
                        InspectionUniqueId: property.inspectionUniqueId
                    }));
                    setInspectionLists(propertyList);
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const closeAddFrequency = () => {
        setOpenAddFrequency(false);
    };

    const renderAllTenants = () => {
  const allTenants = [
    ...primarytenantDetails.map(t => ({ ...t, type: "Primary Tenant" })),
    ...secondarytenantDetails.map(t => ({ ...t, type: "Secondary Tenant" }))
  ];

  const tenantChunks = chunk(allTenants, 2); // breaks into rows of 2

  return tenantChunks.map((row, rowIndex) => (
    <div className="row" key={`tenant-row-${rowIndex}`}>
      {row.map((tenant, colIndex) => (
        <div key={`tenant-${colIndex}`} className="col-md-6 mt-2">
          <div className="detailsContainer">
            <div className="sectionHeader">{tenant.type}</div>
            <div className="owner-details">
              <ShowValue Label="Name" setData={tenant.getFullName || "-"} />
              <ShowValue Label="Email" setData={tenant.tenantEmail || "-"} />
              <ShowValue Label="Phone" setData={tenant.tenantMobile || "-"} />
            </div>
          </div>
        </div>
      ))}
    </div>
  ));
};

const handleFile = (e,data) => {
    const api = data.InspectionType === "Entry" ? generateentryexitinspectionreport : generateroutineinspectionreport;
    const baseUrl = `${api}?InspectionUniqueId=${data.InspectionUniqueId}`;

    showSpinner();

    fetch(baseUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    })
        .then(async (res) => {
            if (!res.ok) {
                throw new Error("Failed to generate inspection report");
            }

            // Extract filename from Content-Disposition header
            const disposition = res.headers.get("Content-Disposition");
            let fileName = "generateReport.pdf";
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match?.[1]) {
                    fileName = match[1];
                }
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            ToastRef.current.notify(["success", "Report downloaded successfully"]);
            getWithdrawalsList(1, 10);
        })
        .finally(() => {
            hideSpinner();
        });
        
};

const handleManageTenant = () => {
    dynamicUrl(navigate, "ManageTenant" + `?propertyUID=${propertyUId}`);
}
    const actionArray = [
        { key: '1', label: (<a onClick={() => handleManageTenant()}>Manage Tenant</a>) },
    ];

        const closePropertyRenewal = () => {
        setOpenAddAgreement(false)
    }

    const handleChange = (e,val) => {
        if(val === "start"){
            setAgreementStartDate(e.target.value)
        }else{
            setAgreementEndDate(e.target.value)
        }

    }

     const AddUpdateAgreement = () => {
            const baseUrl = addupdateagreementterms;
            let data = {
                id: 0,
                fromDate: agreementStartDate,
                toDate: agreementEndDate,
                tenantFolioId: getDetails?.tenantFolioDetails.id,
                propertyId: getDetails?.propertyId
            };
            makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                       setOpenAddAgreement(false);
                       ToastRef.current.notify(["success", response.message]);
                    } else {
                        alert(`Message: ${response.message}`);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        };

    const hasConveyancerData = (data) => data && (data.firmName || data.principalName || data.email || data.phone || data.address);

    return (
        <div>
            <div className="col-12 px-0 changedateantdstyle">
                <div className="col-12 px-0 daily-date-style">
                    <SubNav
                        title={"Property Details"}
                        goback={handleGodBack}
                        extraData={true}
                    />
                    <ToastAlert ref={ToastRef} />

                    <div style={{ display: "flex", padding: "5px", background: 'white', margin: '5px 15px', justifyContent:'space-between' }}>
                        <div style={{ display: "flex"}}>
                            {tabs.map((tab) => (
                                <div
                                    key={tab}
                                    className={`button ${activeTab === tab ? "active-tab" : ""}`}
                                    onClick={() => handleTabs(tab)}
                                >
                                    {tab}
                                </div>
                            ))}
                        </div>
                        <div>
                            <Dropdown menu={{ items: actionArray }} placement="bottomRight">
                                <Button className="withdraw-btn mr-2">Actions</Button>
                            </Dropdown>
                        </div>
                    </div>
                    {activeTab === "Overview" ?
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <div className="p-3">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="detailsLabel">Property</div>
                                    <div className="editbtn" onClick={() => handleOpenProperty(1)}><EditOutlined className="mr-1" /> Edit</div>
                                </div>

                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='Address' setData={getDetails?.getFormatedAddress} />
                                    <ShowValue Label='Type' setData={getDetails?.sPropertyType} />
                                    <ShowValue Label='Attributes' setData={<>
                                        <BiBed style={{ fontSize: '20px' }} />{"\u00A0"}{getDetails?.countBedrooms + getDetails?.countToilets}
                                        {"\u00A0\u00A0\u00A0"}
                                        <BiBath style={{ fontSize: '20px' }} />{"\u00A0"}{getDetails?.countBathrooms}
                                        {"\u00A0\u00A0\u00A0"}
                                        <BiCar style={{ fontSize: '20px' }} />{"\u00A0"}{getDetails?.countCarParking + getDetails?.countGarageSpace}
                                    </>} />
                                    <ShowValue Label='Assigned To' setData={getDetails?.agent_Name ? getDetails?.agent_Name : "-"} />
                                    <ShowValue Label='Features' setData={getDetails?.addUpdatePropertyAttributesModel ? getTrueProperties(getDetails?.addUpdatePropertyAttributesModel) : "-"} />
                                </div>
                            </div>

                            <div className="p-3">

                                <>
                                    {getDetails?.contactlistModel?.length > 0 ?
                                        <div>
                                            <div className="detailsLabel">Owner</div>
                                            <div className="detailsCollapse mt-2 d-flex justify-content-between">
                                                <div onClick={handleOwner}>
                                                    {ownerCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Owner Details
                                                </div>
                                                <div className="d-flex">
                                                    {/* <div className="d-flex align-items-center" onClick={() => handleOpenProperty(2)}>
                                                        <img src="/assets/images/add.png" width={25} alt="add icon" /> Add Owner
                                                    </div> */}
                                                    <div title="view folio" className="editbtn ml-3" onClick={() => handlefolio("Owner")}>
                                                        <DollarOutlined className="mr-1" /> Folio
                                                    </div>
                                                    <div className="ml-2 editbtn" onClick={() => handleOpenProperty(2)}>
                                                        <EditOutlined className="mr-1" />Edit
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : <div className="detailsCollapse d-flex align-items-center" onClick={() => handleOpenProperty(2)}>
                                            <img src="/assets/images/add.png" width={25} alt="add icon" /> Add Owner
                                        </div>}
                                    {ownerCollapse && (
                                        <div className="row">
                                            {renderOwnerDetails("Primary Owner", primaryOwners)}
                                            {renderOwnerDetails("Secondary Owner", secondaryOwners)}
                                        </div>
                                        )}

                                </>

                            </div>

                            <div className="p-3">

                                <>
                                    {getDetails?.tenantDetails?.length > 0 ?
                                        <div>
                                            <div className="d-flex justify-content-between">
                                                <div className="detailsLabel">Tenant</div>
                                            </div>
                                            {getDetails?.tenantDetails?.length > 0 ?
                                                <div className="d-flex justify-content-between detailsCollapse mt-2" >
                                                    <div onClick={handleTenant}>{tenantCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Tenant Details</div>
                                                    <div className="d-flex">
                                                        {/* <div className="d-flex align-items-center detailsCollapse mr-2" onClick={handleOpenAddTenant}><img src="/assets/images/add.png" width={25} /> Add Tenants</div> */}
                                                        <div className="editbtn " onClick={() => handleOpenAddTenant(primarytenantDetails[0]?.tenantId, "edit")}>
                                                            <EditOutlined className="mr-1" /> Edit
                                                        </div>
                                                    </div>
                                                </div> : null}
                                            {tenantCollapse && (
                                                <div className="mt-2">
                                                    {renderAllTenants()}
                                                </div>
                                            )}

                                                
                                            <div className="d-flex justify-content-between mt-2">
                                                <div className="detailsCollapse mt-2" onClick={handleTenantFolid}>
                                                    {tenantFolipCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Tenant Account Folio <Tag color="geekblue">Current</Tag> 
                                                </div>
                                                <div className="d-flex">
                                                    {getDetails?.contactlistModel?.length > 0 ? <div className="editbtn mr-3" onClick={handleOpenReceipt}>
                                                        <PlusOutlined className="mr-1" />Add Receipt
                                                    </div> : null}
                                                    <div className="editbtn " onClick={() => handleOpenAddTenant(primarytenantDetails[0]?.tenantId, "edit", "Rent Details")}>
                                                        <EditOutlined className="mr-1" />Edit
                                                    </div>
                                                    <div title="view folio" className="editbtn ml-3" onClick={() => handlefolio("Tenant")}>
                                                        <DollarOutlined className="mr-1" /> Folio
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : <div className="d-flex align-items-center detailsCollapse" onClick={handleOpenAddTenant}><img src="/assets/images/add.png" width={25} /> Add Tenants</div>}
                                    {tenantFolipCollapse ? renderTenantPortfolioDetails() : null}

                                </>

                            </div>

                            <div className="p-3">
                                <div className="detailsCollapse mt-2" onClick={handleAgreement}>{agreementCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Agreement</div>
                                {agreementCollapse ?
                                    <div className="d-flex">
                                        <div className="mt-2 detailsContainer mr-1">
                                            <Table dataSource={enhancedData} columns={columns} rowKey="key" pagination={false} />

                                        </div>
                                    </div> : null}
                            </div>

                            <div className="p-3">

                                <>
                                    {getDetails?.listingDetails?.length > 0 ?
                                        <div>
                                            <div className="detailsLabel">Listings</div>
                                            <div className="detailsCollapse mt-2 d-flex justify-content-between">
                                                <div onClick={handleListings}>
                                                    {listingCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Property Listings
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => handleOpenProperty(3)}>
                                                    <img src="/assets/images/add.png" width={25} alt="add icon" /> Add Property Listings
                                                </div>
                                            </div>
                                        </div> : <div className="detailsCollapse d-flex align-items-center" onClick={() => handleOpenProperty(3)}>
                                            <img src="/assets/images/add.png" width={25} alt="add icon" /> Add Property Listings
                                        </div>}
                                    {listingCollapse && (
                                        <div className="row">
                                            {renderListingDetails("Sale Listing", saleListing)}
                                            {renderListingDetails("Rent Listing", rentListing)}
                                        </div>)}
                                </>

                            </div>

                            {getDetails?.propertyHeading ? (
                                <div className="p-3">
                                    <div className="d-flex justify-content-between">
                                        <div className="detailsCollapse mt-2" onClick={handlePhotos}>{photosCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Photos</div>
                                        <div className="editbtn" onClick={() => handleOpenProperty(3)}>
                                            <EditOutlined className="mr-1" />Edit
                                        </div>
                                    </div>
                                    {photosCollapse ?
                                        <div className="d-flex">
                                            <div className="mt-2 detailsContainer mr-1">
                                                <span style={{ fontWeight: '500', fontSize: '16px' }}>{getDetails.propertyHeading}</span>
                                                <div style={{ fontSize: '14px', color: '#818584' }}><br />
                                                    {getDetails.propertyDescription}
                                                </div><br />
                                                <div className="d-flex">
                                                    {galleryPropertyImages.length > 0 ? <div className="col-lg-6">
                                                        <div className="detailsCollapse mt-2 mb-2">Property Images</div>
                                                        <ImageGalleryModal filePath={false} images={galleryPropertyImages.length > 0 ? galleryPropertyImages : []} />
                                                    </div> : null}
                                                    {galleryFloorImages.length > 0 ?
                                                        <div className="col-lg-6">
                                                            <div className="detailsCollapse mt-2 mb-2">Property Floor Plan</div>
                                                            <ImageGalleryModal filePath={false} images={galleryFloorImages.length > 0 ? galleryFloorImages : []} />
                                                        </div> : null}
                                                </div>
                                            </div>

                                        </div> : null}
                                </div>) : ''}

                            {(hasConveyancerData(getDetails?.propertySellerConvyencor) ||
                                hasConveyancerData(getDetails?.propertyBuyerConvyencor)) && (
                                    <div className="p-3">
                                        <div className="d-flex justify-content-between">
                                            <div className="detailsCollapse mt-2" onClick={handleLegal}>
                                                {legalCollapse ? (
                                                    <IoIosArrowDown style={{ fontSize: "20px" }} />
                                                ) : (
                                                    <IoIosArrowUp style={{ fontSize: "20px" }} />
                                                )}{" "}
                                                Legals
                                            </div>
                                            <div className="editbtn" onClick={() => handleOpenProperty(3)}>
                                                <EditOutlined className="mr-1" />Edit
                                            </div>
                                        </div>
                                        {legalCollapse && (
                                            <div className="row">
                                                {hasConveyancerData(getDetails?.propertySellerConvyencor) &&
                                                    renderLegalDetails("Seller Solicitor/Conveyancer Details", [getDetails.propertySellerConvyencor])}
                                                {hasConveyancerData(getDetails?.propertyBuyerConvyencor) &&
                                                    renderLegalDetails("Buyer Solicitor/Conveyancer Details", [getDetails.propertyBuyerConvyencor])}
                                            </div>
                                        )}
                                    </div>
                                )}

                            <NewTenantReceipt
                                visible={ppenAddNewReceipt}
                                onClose={closeReceipt}
                                receiptDetails={receiptDetails}
                                supplierValue={true}
                                tenantValue={""}
                                ePaymentModes={ePaymentModes}
                                selectedPaymentMode={selectedPaymentMode}
                                setSelectedPaymentMode={setSelectedPaymentMode}
                                optionSupplier={""}
                                fetchingSupplier={""}
                                debounceFetcherSupplier={""}
                                handleSearchSupplier={""}
                                handleClearSupplier={""}
                                onSubmit={handleReceiptSubmit}
                                ToastRef={ToastRef}
                            />

                            <CustomModal title={`Add Renewal Dates for ${getDetails?.getFormatedAddress}`} width={600} closable={closePropertyRenewal} visible={openAddAgreement} onCancel={closePropertyRenewal}
                                modalData={
                                    <div>
                                        <div className="d-flex">
                                            <div style={{ width: "100%" }}>
                                                <div className="ml-3">
                                                    <ShowValue Label="Current Agreement" setData={`${FormatDateView(tenantPortfolioDetails?.agreementStart)}` || "-"} />
                                                </div>
                                                <TextBox isMandatory colVal={12} value={agreementStartDate} type="date" name="date" label={"Agreement Start"} onChange={(e) => handleChange(e, "start")} />
                                                <TextBox isMandatory colVal={12} value={agreementEndDate} type="date" name="date" label={"Agreement End"} onChange={(e) => handleChange(e, "end")} />

                                            </div>
                                        </div>
                                    </div>
                                }
                                footer={
                                    <div>
                                        <div className="property-details-buttons">
                                            <button
                                                className="pdb-cancel"
                                                type="reset"
                                                onClick={closePropertyRenewal}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="pdb-save-changes"
                                                type="button"
                                                onClick={() => AddUpdateAgreement()}
                                            >
                                                Submit
                                            </button>

                                        </div>
                                    </div>
                                }
                            />

                            <CustomModal
                                title={tenantEdit ? "Update Tenant" : "Add Tenant"}
                                width={800}
                                closable={closeTenant}
                                visible={openAddNewtenant}
                                onCancel={closeTenant}
                                modalData={
                                    <div>
                                        <div style={{ display: "flex", padding: "5px", background: 'white' }}>
                                            {tenantTabs.map((tab) => (
                                                <div
                                                    key={tab}
                                                    className={`button ${activeTabTenant === tab ? "active-tab" : ""}`}
                                                    onClick={() => setActiveTabTenant(tab)}
                                                >
                                                    {tab}
                                                </div>
                                            ))}
                                        </div>
                                        {activeTabTenant === "Tenant" ?
                                            <AddTenant tenantId={tenantEdit ? tenantId : null} cancel={closeTenant} getDetails={getDetails} tabChange={handleTabChangeTenant} /> :
                                            activeTabTenant === "Rent Details" ?
                                                <AddTenantFolio tenantId={tenantEdit ? tenantId : null} cancel={closeTenant} getDetails={getDetails} tabChange={handleTabChangeTenant} /> :
                                                <div>
                                                    <Table
                                                        columns={columns2}
                                                        dataSource={paymentMethods.map((item, index) => ({ ...item, key: index }))}
                                                        pagination={false}
                                                        footer={() => (
                                                            <div style={{ textAlign: "right" }}>
                                                                <Button icon={<PlusOutlined />} type="dashed" onClick={handleAddPaymentMethod}>
                                                                    Add
                                                                </Button>
                                                            </div>
                                                        )}
                                                    />
                                                    <div className="property-details-buttons">
                                                        <button className="pdb-cancel" type="reset" onClick={closeTenant}>
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="pdb-save-changes"
                                                            type="button"
                                                            onClick={handleUpdatePaymentMethos}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                }
                                footer={null}
                            />

                            <MainPropertyComponent
                                isVisible={openAddProperty}
                                onClose={closeProperty}
                                propertyUID={propertyUId}
                                currentStep={currentStep}
                                setCurrentStep={setCurrentStep}
                                dpdata={dpdata}
                                getDetails={getDetails}
                                getDocDetails={getDocDetails}
                                resetAllPage={resetAllPage}
                                handleTabChange={handleTabChange}
                                listingType={listingType}
                            />

                        </div> : null}
                    {activeTab === "Documents" ?
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <PropertyDocumentsAgency getDetails={getDetails} docfile={getDocDetails} recallApi={recallApi} />
                        </div> : null}
                    {activeTab === "Maintainance" ?
                        <div className="material-work-desk-new bg-white m-3">
                            <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
                                <div className="col-lg-8">
                                    <span
                                        className={`col-lg-2 col-sm-2 stat-item ${maintainanceStatus === 0 ? 'active' : ''}`}
                                        onClick={() => handleStatClick(0)}
                                    >
                                        New <span className="count">{listCount.newCount}</span>
                                    </span>
                                    <span
                                        className={`col-lg-2 col-sm-2 stat-item ${maintainanceStatus === 2 ? 'active' : ''}`}
                                        onClick={() => handleStatClick(2)}
                                    >
                                        Active <span className="count">{listCount.activeCount}</span>
                                    </span>
                                    <span
                                        className={`col-lg-2 col-sm-2 stat-item ${maintainanceStatus === 1 ? 'active' : ''}`}
                                        onClick={() => handleStatClick(1)}
                                    >
                                        Rejected <span className="count">{listCount.rejectedCount}</span>
                                    </span>
                                    <span
                                        className={`col-lg-2 col-sm-2 stat-item ${maintainanceStatus === 10 ? 'active' : ''}`}
                                        onClick={() => handleStatClick(10)}
                                    >
                                        Completed <span className="count">{listCount.completedCount}</span>
                                    </span>

                                </div>
                            </div>
                            <AntdTableExample
                                label="List of Maintainance"
                                dataSource={maintainanceList}
                                globalSearch
                                hideCol={"maintenanceUniqueId"}
                                tagColumns={tabColumns}
                            />
                        </div>
                        : null}
                    {activeTab === "Inspection" ?
                        <div className="material-work-desk-new bg-white m-3">
                            <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
                                <div style={{ float: 'right' }}>
                                    <Button style={{ background: "#155C75", color: '#fff' }} onClick={() => setOpenAddFrequency(true)}>
                                        Add Frequency
                                    </Button>
                                </div>


                                <AntdTableExample
                                    label="List Inspection"
                                    dataSource={inspectionLists}
                                    hideCol={"InspectionUniqueId"}
                                    currentPage={1}
                                    totalRows={10}
                                    totalRecords={0}
                                    onRowClick={handleFile}
                                />
                            </div>
                            <CustomModal
                                title={"Add Frequency"}
                                width={600}
                                closable={closeAddFrequency}
                                visible={openAddFrequency}
                                onCancel={closeAddFrequency}
                                footer={null}
                                modalData={
                                    <div>
                                        <div className="col-lg-12" style={{ padding: "0px 30px" }}>
                                            <label className="s1">Routine Inspection Frequency</label>
                                            <div style={{ marginLeft: "-12px" }} className="d-flex align-items-center">
                                                <TextBox
                                                    colVal={8}
                                                    value={inspectionData.InspectionFrequency}
                                                    name="InspectionFrequency"
                                                    onChange={(e) =>
                                                        setInspectionData((prev) => ({
                                                            ...prev,
                                                            InspectionFrequency: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <ToggleTabs
                                                    className="mt-3"
                                                    tabs={inspectionAccesstabs}
                                                    externalTabValue={inspectionData.InspectionFrequencyType}
                                                    onTabChange={(val) =>
                                                        setInspectionData((prev) => ({
                                                            ...prev,
                                                            InspectionFrequencyType: val,
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="p-3">
                                            <TextBox
                                                colVal={8}
                                                type="date"
                                                name="InspectionDue"
                                                value={inspectionData.InspectionDue}
                                                label="Routine Inspection Due"
                                                onChange={(e) =>
                                                    setInspectionData((prev) => ({
                                                        ...prev,
                                                        InspectionDue: e.target.value,
                                                    }))
                                                }
                                            />
                                        </div>

                                        <div className="property-details-buttons">
                                            <button className="pdb-cancel" type="reset" onClick={closeAddFrequency}>
                                                Cancel
                                            </button>
                                            <button
                                                className="pdb-save-changes"
                                                type="button"
                                                onClick={handleInspection}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                        : null}
                </div>
            </div>
        </div>
    );
};

export default ViewPropertDetails;


